import { editor } from 'monaco-editor'

export const DEFAULT_HEIGHT: number = 300

export const CODE_FIELD_COMMON_OPTIONS: editor.IStandaloneEditorConstructionOptions = {
  minimap: { enabled: false },
  renderLineHighlightOnlyWhenFocus: true,
  scrollbar: { alwaysConsumeMouseWheel: false },
  scrollBeyondLastLine: false,
  stickyScroll: { enabled: false },
} as const
